module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }